import m from 'mithril'
import {Component} from '@codeurs/front'

import './container.less'

export default class Container extends Component<{
	[key: string]: any
}> {
	view() {
		const {...attrs} = this.attrs
		return m('.container', {...attrs}, this.children)
	}
}
